<div class="flex grow flex-col">
  <div class="font-bold">{{ label() }}</div>
  @if (!isEmpty()) {
    @if (displayDate(); as displayDateValue) {
      <div>
        {{ displayDateValue | moment | amDateFormat: dateFormat }}
      </div>
      <div class="text-xs opacity-50">{{ timeDistance() }}</div>
    }
  } @else {
    <div class="text-xs opacity-50">{{ emptyMessage() }}</div>
  }
</div>
